
      import InProgress from './in-progress.vue'
      import type { App, Plugin } from 'vue'

      export const InProgressPlugin: Plugin = {
        install(app: App) {
          app.component('InProgress', InProgress)
        },
      }
      export { InProgress }
      